/* Starly storefront (layout hm): Starly cart drawer, add to cart, gallery, menu, bundle rows. */
(function () {
  var drawer = document.getElementById('hm-drawer');
  var inner = document.getElementById('hm-cart-inner');
  var menu = document.getElementById('hm-menu');

  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function refresh() {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?sections=hm-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['hm-cart-drawer'] || '';
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var sec = tmp.firstElementChild;
        inner.innerHTML = sec ? sec.innerHTML : html;
        var body = inner.querySelector('[data-hm-n]');
        var n = body ? body.getAttribute('data-hm-n') : '0';
        document.querySelectorAll('[data-hm-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
        var orphan = inner.querySelector('[data-hm-sp-orphan]');
        if (orphan && !refresh.cleaning) { refresh.cleaning = true; return spSet(orphan.getAttribute('data-hm-sp-orphan'), false).then(refresh).then(function () { refresh.cleaning = false; }, function () { refresh.cleaning = false; }); }
      });
  }
  window.hmCartRefresh = function () { return refresh().then(openDrawer); };

  /* shipping protection (SE/NO/DK, 2026-10-11): PDP toggle adds it with the bundle, drawer toggle adds/removes it, never left alone in the cart */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function spSet(id, want) {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var has = c.items.some(function (i) { return String(i.variant_id) === String(id); });
      if (want && !has) return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) });
      if (!want && has) return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(id), quantity: 0 }) });
    });
  }
  /* guard: shipping protection can never be bought alone or more than once (checked on every page load and before checkout) */
  function spGuard() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var sp = c.items.filter(function (i) { return i.handle === 'starly-shipping-protection'; });
      if (!sp.length) return false;
      var q = c.items.length > sp.length ? 1 : 0;
      if (sp.length === 1 && sp[0].quantity === q) return false;
      var upd = {}; sp.forEach(function (i, k) { upd[i.key] = k === 0 ? q : 0; });
      return fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(function () { return true; });
    });
  }
  spGuard().then(function (changed) {
    if (!changed) return;
    if (/\/cart\/?$/.test(location.pathname)) location.reload(); else if (inner) refresh();
  }, function () {});
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || f.hasAttribute('data-hm-add') || f.getAttribute('data-hm-guarded') === '1') return;
    if (!/\/cart\/?$/.test(f.getAttribute('action') || '')) return;
    e.preventDefault();
    var btn = f.querySelector('[name=checkout]');
    var go = function () { f.setAttribute('data-hm-guarded', '1'); if (btn) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); } f.submit(); };
    spGuard().then(go, go);
  }, true);

  /* drawer: swap a 2-/3-pack for the 4-pack (Family pack) in one click */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hm-up]');
    if (!b) return;
    e.preventDefault(); b.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-v4'), 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-hm-up'), quantity: 0 }) }); })
      .then(refresh, refresh);
  });

  document.addEventListener('change', function (e) {
    var t = e.target.closest && e.target.closest('[data-hm-sp-toggle]');
    if (!t) return;
    t.disabled = true;
    spSet(t.getAttribute('data-hm-sp-toggle'), t.checked).then(refresh, refresh);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hm-open],[data-hm-close],[data-hm-menu],[data-hm-qty]');
    if (!t) return;
    if (t.hasAttribute('data-hm-open')) { e.preventDefault(); refresh().then(openDrawer); }
    else if (t.hasAttribute('data-hm-close')) { closeDrawer(); }
    else if (t.hasAttribute('data-hm-menu')) { if (menu) menu.classList.toggle('is-open'); }
    else if (t.hasAttribute('data-hm-qty')) {
      t.disabled = true;
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: t.getAttribute('data-hm-qty'), quantity: parseInt(t.getAttribute('data-q'), 10) }) })
        .then(refresh);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); if (menu) menu.classList.remove('is-open'); } });
  if (menu) menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); }); });

  /* add to cart -> Starly drawer */
  document.querySelectorAll('form[data-hm-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn.innerHTML; btn.disabled = true; btn.innerHTML = btn.getAttribute('data-adding') || 'Adding…';
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { var sp = document.querySelector('[data-hm-sp]'); return sp && sp.checked ? spSet(sp.getAttribute('data-hm-sp'), true).catch(function () {}) : null; })
        .then(function () { return refresh(); })
        .then(function () { btn.disabled = false; btn.innerHTML = label; openDrawer(); })
        .catch(function () { btn.disabled = false; btn.innerHTML = label; form.submit(); });
    });
  });

  /* gallery */
  var gal = document.querySelector('[data-hm-gal]');
  if (gal) {
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.hm-gal__main img'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.hm-gal__thumbs button'));
    var dotsBox = gal.querySelector('.hm-gal__dots');
    var cur = 0;
    var show = function (i) {
      if (!imgs.length) return;
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (el, k) { el.classList.toggle('is-on', k === cur); });
      if (dotsBox) dotsBox.querySelectorAll('span').forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
    };
    if (dotsBox) {
      dotsBox.innerHTML = imgs.map(function () { return '<span></span>'; }).join('');
      dotsBox.querySelectorAll('span').forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    gal.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { show(cur + parseInt(b.dataset.dir, 10)); }); });
    var main = gal.querySelector('.hm-gal__main'), x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null;
      });
    }
    show(0);
  }

  /* bundle rows -> variant id, price display, ?variant= in the URL */
  var rows = Array.prototype.slice.call(document.querySelectorAll('[data-hm-var]'));
  var inp = document.querySelector('form[data-hm-add] input[name=id]');
  var nows = document.querySelectorAll('[data-hm-now]');
  var was = document.querySelector('[data-hm-was]');
  var sv = document.querySelector('[data-hm-save]');
  function pick(r, push) {
    rows.forEach(function (x) { var on = x === r; x.classList.toggle('is-on', on); var i = x.querySelector('input'); if (i) i.checked = on; });
    var id = r.getAttribute('data-hm-var');
    if (inp) inp.value = id;
    nows.forEach(function (n) { n.textContent = r.getAttribute('data-now'); });
    var w = r.getAttribute('data-was'), s = r.getAttribute('data-save');
    if (was) { was.textContent = w; was.hidden = !w; }
    if (sv) { var sfx = sv.getAttribute('data-suffix'); sv.textContent = sfx ? s + '%' + sfx : (sv.getAttribute('data-label') || 'Save') + ' ' + s + '%'; sv.hidden = !w || s === '0'; }
    if (push) {
      try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    }
  }
  rows.forEach(function (r) { r.addEventListener('click', function (e) { e.preventDefault(); pick(r, true); }); });
  var on = document.querySelector('[data-hm-var].is-on');
  if (on) pick(on, false);
})();
